import axios from "axios";
import { BASE_URL } from "../config/config";

// ================= GET CART =================
export const getCart = async () => {
  if (window.location.pathname.startsWith("/confirm-order")) {
    return { success: false, data: [] };
  }
  const token = sessionStorage.getItem("token");

  // ✅ No token → early return
  if (!token) {
    return {
      success: false,
      data: [],
      message: "No token found",
    };
  }

  try {
    const response = await axios.post(
      `${BASE_URL}/getCart`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        timeout: 10000, // ⏱️ avoid hanging request
      }
    );

    return {
      success: true,
      data: response.data,
      message: "Cart fetched successfully",
    };

  } catch (error) {
    console.error("getCart Error 👉", error);

    // 🔐 Unauthorized (token expired)
    if (error.response?.status === 401) {
      sessionStorage.removeItem("token");

      return {
        success: false,
        data: [],
        message: "Session expired. Please login again.",
        logout: true, // 🔥 useful flag
      };
    }

    // 🌐 Network error
    if (!error.response) {
      return {
        success: false,
        data: [],
        message: "Network error. Please check your connection.",
      };
    }

    // ⚠️ Backend error
    return {
      success: false,
      data: [],
      message:
        error.response?.data?.message ||
        "Failed to fetch cart",
    };
  }
};


// ================= ADD TO CART =================
export const addToCartAPI = async (product_id) => {
  const token = sessionStorage.getItem("token");
  // console.log("TOKEN FROM SESSION:", sessionStorage.getItem("token"));

  if (!token) return;

  try {
    const response = await axios.post(
      `${BASE_URL}/addToCart`,
      { product_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Add to cart error:", error);
  }
};

// ================= DELETE CART =================
export const deleteCart = async (product_id) => {
  const token = sessionStorage.getItem("token");
  if (!token) return false;

  try {
    const response = await axios.delete(
      `${BASE_URL}/deleteCart`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { product_id },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Delete cart error:", error);
    return false;
  }
};
